import { HoopsApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const useAddHoop = () => {
  let [addHoops] = useAPIAction(
    HoopsApi,
    async (api) => {
      let data = await api.hoopsCreateDraft({
        controlcenterMelcoModelsCreateHoop: {},
      });
      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "managehoops.actions.add",
    }
  );

  return useCallback(async () => {
    return await addHoops();
  }, [addHoops]);
};
